import server_api from "./server_api";

export const getNotificationCount = () => {
  return server_api.get("/notifications/notification/get_count");
};

export const getNotifications = (page = 1) => {
  return server_api.get(`/notifications/notification?page=${page}`);
};
export const readNotification = (id) => {
  return server_api.get(`/notifications/notification/${id}/read`);
};

export const getCombinedNotificationCount = () => {
  return server_api.get("/notifications/notification/combined-count");
};

export const getCombinedNotifications = (page = 1) => {
  return server_api.get(
    `/notifications/notification/combined-get?page=${page}`
  );
};
export const readCombinedNotification = (id) => {
  return server_api.get(`/stock/stock-notification/${id}/read`);
};
